import { JarvisWebHttpClient } from '@jarvis/web-http';
import { IAuthProviderService } from '../../../services/authProviderService';
import { AccessPoliciesEndPointReturnType } from './types';
import AuthenticationProviderEnum from '../../../config/authenticationProviderEnum';
import { getStratusBaseUrl } from '../../../clients/stackUtils';
import IApplicationService from '../../../services/applicationService/IApplicationService';
import { ApplicationContextEnum } from '../../../services/applicationService/enums';

export async function getAccessPolicies(
  authProvider: IAuthProviderService,
  applicationService: IApplicationService
): Promise<AccessPoliciesEndPointReturnType> {
  const httpClient = new JarvisWebHttpClient({
    defaultAuthProvider: authProvider
  });

  const authenticationProvider = applicationService.getAuthenticationProvider();
  const applicationContext = applicationService.getApplicationContext();

  const url = '/session/v1/scopes';

  // JShell CF proxy
  let baseUrl = '/api';

  if (applicationContext === ApplicationContextEnum.ADAPTER) {
    const portalStack = applicationService.getPortalStack();
    baseUrl = `${getStratusBaseUrl(portalStack)}/portalsvc`;
  }

  // In case of Onecloud we need to use the JShell Apigee URL directly instead of passing through JShell CF proxy
  else if (authenticationProvider === AuthenticationProviderEnum.coptor) {
    const authStack = applicationService.getAuthStack();
    baseUrl = `${getStratusBaseUrl(authStack)}/portalsvc`;
  }

  const payload: { data: AccessPoliciesEndPointReturnType } =
    await httpClient.get({
      url: `${baseUrl}${url}`
    });

  return payload?.data;
}
